import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 16, interactive = false, onChange }) => {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange?.(n)}
          data-testid={interactive ? `star-${n}` : undefined}
          className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
        >
          <Star
            size={size}
            strokeWidth={2.5}
            className={n <= Math.round(value) ? "fill-[#E6B31E] text-[#E6B31E]" : "text-black/25"}
          />
        </button>
      ))}
    </div>
  );
};
